import { SubscriptionLabel } from "@custom-types/subscription-types";
import { AdminAPITypes } from "@stellar/api-logic";
import { CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { capitalizeFirstLetter } from "@utils/string-utils";

/** URL for the page to request a quote on a subscription */
export const REQUEST_A_QUOTE_URL = "https://www.holobuilder.com/pricing";

/**
 * The priority value of a each subscription represented by a number.
 * The higher the number maps to a subscription with higher priority.
 */
export const SUBSCRIPTION_PRIORITY: Record<SubscriptionLabel, number> = {
  [SubscriptionLabel.enterprise360PointCloud]: 10,
  [SubscriptionLabel.enterprisePointCloud]: 9,
  [SubscriptionLabel.enterprise360]: 8,
  [SubscriptionLabel.proPointCloud]: 7,
  [SubscriptionLabel.pro360]: 6,
  [SubscriptionLabel.standardPointCloud]: 5,
  [SubscriptionLabel.standard360]: 4,
  [SubscriptionLabel.trial360PointCloud]: 3,
  [SubscriptionLabel.trialPointCloud]: 2,
  [SubscriptionLabel.trial360]: 1,
};

/** Label for each constraint type */
export const CONSTRAINT_LABEL: {
  [key in AdminAPITypes.EConstraintType]: string;
} = {
  [AdminAPITypes.EConstraintType.projectArea]: "area",
  [AdminAPITypes.EConstraintType.projectCount]: "active projects",
  [AdminAPITypes.EConstraintType.userCount]: "users",
  [AdminAPITypes.EConstraintType.waypoint]: "captures Location",
  [AdminAPITypes.EConstraintType.timetravelOnWaypoint]: "captures per Location",
  [AdminAPITypes.EConstraintType.storage]: "storage",
  [AdminAPITypes.EConstraintType.userRole]: "active members",
  [AdminAPITypes.EConstraintType.credits]: capitalizeFirstLetter(CREDITS_DISPLAY_NAME),
};
